import { $Qll, $Q } from '../utils/query-selector';
import { createInterception } from '../utils/script-defer';
import { destroyZoom, initZoom } from './product-zoom';
import { loadNavigation, loadPagination } from './slider-component';

/**
 * Init product media slider depends media query width
 * @returns {VoidFunction} Mount the product media
 */
export function productMedia() {
  initProductMedia().then((e) => {
    let zoomElement = null;
    zoomElement = initZoom(e.swiper.slides[e.swiper.activeIndex]);
    e.swiper.on('slideChange', (swiper) => {
      if (zoomElement) {
        destroyZoom(zoomElement, swiper.slides[swiper.activeIndex]);
      }
      zoomElement = initZoom(swiper.slides[swiper.activeIndex]);
    });
  });
}

/**
 * Init custom element of swiper component (slider mount)
 * @returns {VoidFunction}
 */
const initProductMedia = async () => {
  const thumbs = $Q('#product-media-thumbs-js');
  const media = $Q('#product-media-js');

  if (!thumbs) return;

  const thumbsParams = {
    slidesPerView: 4,
    spaceBetween: 0,
    direction: 'vertical',
  };

  Object.assign(thumbs, thumbsParams);
  thumbs.initialize();

  let mediaParams = {
    thumbs: {
      swiper: thumbs,
    },
    loop: true,
    crossFade: true,
    creativeEffect: {
      prev: {
        shadow: true,
        translate: [0, 0, -400],
      },
      next: {
        translate: ['100%', 0, 0],
      },
    },
  };

  mediaParams = loadNavigation(media, mediaParams);
  mediaParams = loadPagination(media, mediaParams);

  Object.assign(media, mediaParams);
  media.initialize();
  return media;
};

/**
 * Visible image on scrolling
 * @param {HTMLElement} target - Id bullet element
 * @param {HTMLElement} bullets - Bullets list - Iterable
 * @returns {VoidFunction}
 */
const imageVisible = (target, bullets) => {
  const { id } = target;
  if (!id) return;

  const bulletTarget = $Q(`.product-bullet-js[data-id='${id}']`);

  bullets.forEach((bullet) => bullet.classList.remove('visible'));
  return bulletTarget.classList.add('visible');
};

/**
 * Mobile experience product media slider
 */
export const bulletsMobile = () => {
  const images = $Qll('.product-image-js');
  const bullets = $Qll('.product-bullet-js');

  images.forEach((image) =>
    createInterception(image, () => imageVisible(image, bullets), {
      rootMargin: '0px',
      threshold: 0.5,
    })
  );

  bullets.forEach((bullet) => {
    bullet.addEventListener('click', () => {
      const {
        dataset: { id },
      } = bullet;
      if (!id) return;

      const imageFocus = $Q(`[id='${id}']`);
      imageFocus.scrollIntoView(false);
    });
  });
};

export default productMedia;
